// extracted by mini-css-extract-plugin
export default {"menu":"Profile_menu__BOUuK","section":"Profile_section__rZCk0","sectionTitle":"Profile_sectionTitle__-4E9e","menuItem":"Profile_menuItem__TeIRN","chevron":"Profile_chevron__P7KZU"};